/*
 * @Author: 侯鹏许(houpengxu@qq.com)
 * @Date: 2020-03-10 17:03:58
 * @LastEditors: 侯鹏许
 * @LastEditTime: 2021-03-03 19:11:42
 * @Description: file content
 */

Vue.component("vue_showimg", {
  props: {
    img_url: String,
    is_show_tips: Boolean,
    tips: String
  },
  template: `<div class="vue_showimg">
  <div class="vue_showimg_mask">
    <div class="vue_showimg_content">
      <div class="b1">
        <img :src="img_url"/>
      </div>
      <div class="tips" v-if="is_show_tips"> {{tips||"提示：可长按保存此图片哦"}} </div>
      <div class="close">
        <img @click="clickClose" src='https://assets.rurushishi.com/yq-rs-h5/encourage_box_close.png'/>
      </div>
    </div>
  </div>
</div>`,
  data() {
    return {
    }
  },
  methods: {
    clickClose: function () {
      this.$emit("close");
    }
  },
  created() {
  }
})
